import React, {Component} from 'react';
import Header from '../../../Containers/Header/Header';
import Footer from '../../../Containers/Footer';
import Loading from "../../../Containers/Loading";
import AttendanceList from "./AttendanceList";

class AttendanceManagement extends Component {
    state = {
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (<div className="beaconWrapper">
            <Header selectedIndex={1}/>
            <AttendanceList/>
            <Footer/>
        </div>);
    }
}

export default AttendanceManagement;


// WEBPACK FOOTER //
// ./src/components/Pages/Attendance/AttendanceManagement/index.js